import { useEffect, useState } from "react";

const useAccomplishments = ({ challenge, histories }) => {
    const [accomplishment, setAccomplishment] = useState(0);

    useEffect(() => {
        const unit = challenge?.unit;
        const list = histories["challenge-" + challenge?.id] || [];
        let count = 0;

        for (let x = 0; x < list?.length; x++) {

            if (unit == "sessions") {
                if (list[x]?.percentage >= 80) {
                    count++;
                }
            } else if (unit == "minutes") {
                count += (Math.round(((list[x]?.watchedtime * 1) / 60) * 100) / 100);
            } else if (unit == "steps") {

            }

        }

        setAccomplishment(count);

    }, [histories, challenge?.id]);

    return { accomplishment };
}

export default useAccomplishments;
